
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import {
  ICashOrderDTO,
  resolveSolCustomerOrderDescriptionKey,
  resolveSolCustomerOrderType,
} from "@/entities";

@Component({
  name: "reject-order-row-modal",
  components: { PModal },
})
export default class RejectOrderRowModal extends Vue {
  @Prop({ required: false, default: null }) order!: ICashOrderDTO | null;

  localComments = "";

  onShow(): void {
    this.localComments = "";
  }

  get modalTitle(): string {
    const orderType = resolveSolCustomerOrderType(this.order?.productCode);
    const descriptionKey = resolveSolCustomerOrderDescriptionKey(orderType);
    const typeLabel = descriptionKey ? this.$t(descriptionKey).toString() : "";
    const baseTitle = this.$t("label.rejectOrderTitle").toString();
    return typeLabel ? `${baseTitle} - ${typeLabel}` : baseTitle;
  }

  onConfirm(): void {
    this.$emit("reject", this.localComments);
  }
}
